import TopPanel from './top-panel';
import SearchBox from './search-box';
import InitialSearchPanel from './search-results/initial-search-panel';
import SearchResults from './search-results/search-results';
import { useAppSelector } from '../data/store';

const Wrapper = () => {
    const touched = useAppSelector(store => store.root.touched);

    return (
        <div className="top-search-m__wrapper bg-white text-gray-700 fixed top-0 left-0 right-0 bottom-0 w-screen h-screen flex flex-col" style={{
            zIndex: 99999,
        }}>
            <TopPanel />
            <SearchBox />

            { !touched && <InitialSearchPanel /> }
            { touched && <SearchResults /> }
        </div>
    )
};

export default Wrapper;